import defaultState from "./state";

const mantenedorSelReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_MANTENEDOR_PRESTACIONES_SEL": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SET_PRESTACION_SEL": {
      return Object.assign({}, state, {
        prestacion: action.data,
      });
    }
    case "SET_FILTROS_PRESTACIONES_SEL": {
      return Object.assign({}, state, {
        filtrosPrestacionesSel: action.filtros,
      });
    }
    case "SET_LISTA_PRESTACIONES_SEL": {
      return Object.assign({}, state, {
        listaPrestacionesSel: action.data,
        listaPrestacionesSelFiltradas: action.data,
      });
    }
    case "SET_LISTA_PRESTACIONES_SEL_FILTRADAS": {
      return Object.assign({}, state, {
        listaPrestacionesSelFiltradas: action.data,
      });
    }
    case "OPEN_CLOSE_MODAL_EDITAR_PRESTACIONES_SEL": {
      return Object.assign({}, state, {
        isOpenModalEditarPrestacion: action.isOpen,
        prestacion: action.selectedPrestacion,
        isNewPrestacion: action.isNew,
      });
    }
    case "OPEN_CLOSE_MODAL_DESACTIVAR_PRESTACION_SEL": {
      return Object.assign({}, state, {
        isOpenModalDesactivarPrestacion: action.isOpen,
        prestacion: action.selectedPrestacion,
      });
    }
    case "OPEN_CLOSE_MODAL_ELIMINAR_PRESTACION_SEL": {
      return Object.assign({}, state, {
        isOpenModalEliminarPrestacion: action.isOpen,
        prestacion: action.selectedPrestacion,
      });
    }
    default:
      return state;
  }
};

export default mantenedorSelReducer;
